'use strict';

exports.__esModule = true;
exports.default = reducer;

var _actions = require('./actions');

var _constants = require('./constants');

function position(props) {
  var state = arguments.length <= 1 || arguments[1] === undefined ? props.defaultPosition : arguments[1];
  var action = arguments[2];

  return action.type === _actions.CHANGE_POSITION ? _constants.POSITIONS[(_constants.POSITIONS.indexOf(state) + 1) % _constants.POSITIONS.length] : state;
}

function size(props) {
  var state = arguments.length <= 1 || arguments[1] === undefined ? props.defaultSize : arguments[1];
  var action = arguments[2];

  return action.type === _actions.CHANGE_SIZE ? action.size : state;
}

function isVisible(props) {
  var state = arguments.length <= 1 || arguments[1] === undefined ? props.defaultIsVisible : arguments[1];
  var action = arguments[2];

  return action.type === _actions.TOGGLE_VISIBILITY ? !state : state;
}

function childMonitorState(props, state, action) {
  var child = props.children;
  return child.type.update(child.props, state, action);
}

function reducer(props) {
  var state = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
  var action = arguments[2];

  return {
    position: position(props, state.position, action),
    isVisible: isVisible(props, state.isVisible, action),
    size: size(props, state.size, action),
    childMonitorState: childMonitorState(props, state.childMonitorState, action)
  };
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-devtools-dock-monitor/lib/reducers.js
 ** module id = 394
 ** module chunks = 0
 **/